import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
    onSuccess: () => console.log('PWA successfully registered'),
    onUpdate: (reg) => {
        console.log('New content is available, activating new service worker...');
        try {
        reg && reg.waiting && reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            // After SW takeover, re-register messaging SW to keep background listeners alive
            if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' }).catch(() => {});
            }
            
            // Set flag to refresh FCM tokens after reload
            localStorage.setItem('refreshFCMTokenAfterSW', 'true');
            
            window.location.reload();
        });
        } catch (e) {
        console.warn('Failed to auto-activate service worker:', e);
        }
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
